import React from 'react';
import s from './Table.scss';
export const Table = ({ columns, items, columnGap, }) => {
    const rowStyle = {
        gridTemplateColumns: columns.map((c) => c.width).join(' '),
        gap: columnGap,
    };
    return (React.createElement("table", { style: { width: '100%' }, className: s.table },
        React.createElement("thead", { className: s.header },
            React.createElement("tr", { className: s.row, style: rowStyle }, columns.map((col, idx) => (React.createElement("th", { key: idx, style: { justifySelf: col.align ?? 'start' } }, col.header))))),
        React.createElement("tbody", null, items.map((item, index) => (React.createElement("tr", { key: index, className: `${s.row} ${s.data}`, style: rowStyle }, columns.map((col, idx) => (React.createElement("td", { key: idx, className: s.rowCell, style: { justifySelf: col.align ?? 'start' } }, col.value(item, index))))))))));
};
//# sourceMappingURL=Table.js.map